import { on, select } from 'helpers/dom'

const selectors = {
  CLOSE_NOTICE_SELECTOR: '.js-close-notice',
  AUTO_CLOSE_NOTICE_SELECTOR: '.js-auto-close-notice',
  NOTICE_HIDE_CLASS: 'notice-hidden'
}

class NoticeMain extends HTMLElement {
  constructor () {
    super()

    this.closeBtn = select(selectors.CLOSE_NOTICE_SELECTOR, this)
    this.autoCloseNotice = select(selectors.AUTO_CLOSE_NOTICE_SELECTOR)

    this.addEvents()
  }

  addEvents () {
    if (this.closeBtn) {
      on('click', this.hide.bind(this), this.closeBtn)

      if (this.autoCloseNotice) {
        setTimeout(this.hide.bind(this), 10000)
      }
    }
  }

  hide () {
    this.classList.add(selectors.NOTICE_HIDE_CLASS)
  }
}

customElements.define('notice-main', NoticeMain)
